// extracted by mini-css-extract-plugin
module.exports = {"root":"Article_root__1lCcJ","tabsWrapper":"Article_tabsWrapper__1BG8l","tab":"Article_tab__EMhhS","active":"Article_active__MMzzy"};